import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Register Service Worker for PWA offline support
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((reg) => {
      console.log("[SW] Registered:", reg.scope);

      // Listen for periodic sync support and register
      if ("periodicSync" in reg) {
        // @ts-expect-error - periodicSync is not yet in standard ServiceWorkerRegistration types
        reg.periodicSync
          .register("sync-periodic-data", {
            minInterval: 15 * 60 * 1000, // 15 minutes
          })
          .catch((err: any) => {
            console.warn("[SW] Periodic sync registration failed:", err);
          });
      }
    })
    .catch((err) => console.error("[SW] Registration failed:", err));

}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
